import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Phone,
  Check,
  Plus,
  MessageSquare,
  ArrowRight,
} from 'lucide-react';

/**
 * Completion actions once the trust chain is settled.
 * @param {Object} props - purchased record plus navigation callbacks.
 */
export default function StepDone({ purchased, onGoSettings, onGoTemplates, onBuyAnother }) {
  const nav = useNavigate();
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-emerald-500/20 inline-flex items-center justify-center">
          <Check className="w-5 h-5 text-emerald-300" />
        </div>
        <div>
          <div className="font-display font-bold text-lg">Number provisioned</div>
          <div className="text-xs text-white/55">Attached to your Messaging Service and ready to use.</div>
        </div>
      </div>
      <div className="p-4 rounded-md border border-civix-border/50 bg-black/20">
        <div className="font-mono text-lg">{purchased.number}</div>
        <div className="text-xs text-white/50 mt-1">Area code {purchased.areaCode || '—'}</div>
      </div>
      <div className="flex flex-wrap gap-3">
        <button onClick={() => nav('/settings/business-card')} className="btn-primary inline-flex items-center gap-2">
          <ArrowRight className="w-4 h-4" /> Next Step: Create Digital Business Card
        </button>
        <button onClick={() => nav('/dashboard')} className="btn-ghost inline-flex items-center gap-2">
          <ArrowRight className="w-4 h-4" /> Go to CRM Dashboard
        </button>
        <button onClick={onGoSettings} className="btn-ghost inline-flex items-center gap-2">
          <Phone className="w-4 h-4" /> Go to Settings → Phone Numbers
        </button>
        <button onClick={onGoTemplates} className="btn-ghost inline-flex items-center gap-2">
          <MessageSquare className="w-4 h-4" /> Configure messaging templates
        </button>
        <button onClick={onBuyAnother} className="btn-ghost inline-flex items-center gap-2">
          <Plus className="w-4 h-4" /> Buy another
        </button>
      </div>
    </div>
  );
}
